module.exports = __webpack_public_path__ + "img/icon3.5cab6bce.png";